import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextArea from 'react-expanding-textarea';
import { placeholder as placeholderStyle } from 'polished';
import Label from '../label';

const GullTextArea = (props) => {
  const {
    label,
    name,
    onChange,
    placeholder,
    hideLabel,
    required,
    value,
    ...rest
  } = props;

  const id = `textarea-${name}`;

  return (
    <TextareaWrap>
      {label &&
        <Label htmlFor={id} hideLabel={hideLabel}>{label}</Label>
      }
      <TextArea
        name={name}
        onChange={onChange}
        placeholder={`${placeholder}${required ? '*' : ''}`}
        value={value}
        id={id}
        required={required}
        {...rest}
      />
    </TextareaWrap>
  );
};

const TextareaWrap = styled.div`
  position: relative;
  padding-bottom: 2rem;
  width: 100%;
  font-size: 1rem;

  textarea {
    padding: 9px 0;
    width: 100%;
    appearance: none;
    font-family: ${props => props.theme.sansFont};
    font-size: inherit;
    line-height: 1.5rem;
    resize: none;
    border-radius: 0;
    border: 0;
    border-bottom: 2px solid ${props => props.theme.black};
    transition: border-color .2s ease;
    outline: none;

    &:focus {
      border-color: ${props => props.theme.blue};
    }

    ${placeholderStyle(`
      font-size: inherit;
      font-family: inherit;
      line-height: inherit;
    `)}
  }
`;

GullTextArea.defaultProps = {
  hideLabel: true,
};

export default GullTextArea;
